export enum PARTNER_POINT_OF_SELL_COLUMNS {
    REDEEM = "redeem",
    TRANSACTIONS = "transactions",
    AMOUNT = "amount",
    ACTIONS = "actions",
}
